export default {
  name: "suppliers",
  data: () => ({
    supplier: {},
    suppliers: [],
    all_suppliers: [],
    suppliers_page: 1,
    suppliers_total: 0,
    data_loading: false,
    load_on_mount: true
  }),
  methods: {
    async get_all_suppliers() {
      const suppliers = this.$communicator.then(this, await this.$communicator("all_suppliers"))
      if (suppliers) {
        this.all_suppliers = suppliers
      }
    },
    async update_suppliers(search) {
      this.data_loading = true
      if (this.$route.params["target"] == "update") {
        const supplier = this.$communicator.then(this, await this.$communicator("supplier", {
          arguments: [this.$route.query["id"]]
        }))

        this.supplier = this.$copy(supplier)
        this.contract_numbers = supplier.contract_numbers && supplier.contract_numbers.length
          ? supplier.contract_numbers
          : []
        this.data_loading = false
        return
      }

      if (typeof search != typeof "invan") {
        search = ""
      }

      const getSuppliersRes = await this.$communicator("suppliers", {
        arguments: [10, this.suppliers_page],
        params: {
          supplier_name: search
        }
      })
      if (getSuppliersRes.data.statusCode == 200 && getSuppliersRes.data.message === 'Success') {
        this.suppliers_total = getSuppliersRes.data.meta.pageCount
        this.suppliers = getSuppliersRes.data.data
      }

      this.data_loading = false
    },
    async remove_suppliers(items) {
      var indices = []
      for (const index in items) {
        indices.push(items[index]._id)
      }
      await this.$communicator("delete_suppliers", {
        params: {
          indexes: indices
        }
      })
      this.$toast.success("Success", { timeout: 2000 });
      this.update_suppliers()
    },
    async save_supplier(path = null) {
      this.loading_supplier = true
      const supplier = this.$copy(this.supplier)
      supplier.contract_numbers = this.contract_numbers.filter(c => c !== '')

      supplier.phone_number = `+${supplier.phone_number.replace(/[^0-9]/g, "")}`
      if (this.$route.params["target"] == "update") {
        const updated = await this.$communicator("update_supplier", {
          arguments: [this.$route.query["id"]],
          params: supplier
        })
        if (updated?.data?.statusCode == 422) {
          this.$toast.error("Already this phone_umber supplier created", { timeout: 2000 });
        }
        else {
          this.$toast.success("Success", { timeout: 2000 });
        }
      }
      else {
        const saved = await this.$communicator("create_supplier", {
          params: supplier
        })
        if (saved?.data?.statusCode == 422) {
          this.$toast.error("Already this phone_umber supplier created", { timeout: 2000 });
        }
        else {
          this.$toast.success("Success", { timeout: 2000 });
        }
      }
      if (path) {
        this.$router.push({ path: path })
      }
      this.loading_supplier = false
    }
  },
  mounted() {
    if (this.load_on_mount) {
      this.update_suppliers()
    }
  },
  computed: {
    all_suppliers_() {
      const all_suppliers = [{ supplier_name: this.$t('all_suppliers'), _id: '' }, ...this.all_suppliers]
      this.$store.state.supplier1 ? this.$store.state.supplier1 : this.supplier = all_suppliers[0]
      return all_suppliers
    },
    main_all_suppliers_() {
      const all_suppliers = [{ supplier_name: this.$t("all_suppliers"), _id: "" }, ...this.all_suppliers]
      let my_supplier = ""
      if (!this.$store.state.main_supplier._id) {
        this.supplier = all_suppliers[0]
      }
      else {
        for (my_supplier of all_suppliers) {
          if (my_supplier._id === this.$store.state.main_supplier._id) {
            this.supplier = my_supplier
          }
        }
      }
      return all_suppliers
    }
  }
}